<template>
  <v-app theme="light">
    <OareAppBar @nav-icon-click="drawer = !drawer" />
    <v-navigation-drawer
      theme="dark"
      v-model="drawer"
      :mobile-breakpoint="'md'"
      color="#002E5D"
    >
      <component :is="sidebarComponent" />
    </v-navigation-drawer>

    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>

    <OareSnackbar />
  </v-app>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import OareSidebar from './components/base/OareSidebar/index.vue';

export default defineComponent({
  name: 'App',
  components: {
    OareSidebar,
  },
  setup() {
    const route = useRoute();
    const drawer = ref(true);
    const hasLanded = ref(false);

    const sidebarComponent = computed(() => {
      const routeName = route.name as string | undefined | null;
      if (routeName && routeName.includes('dashboard')) {
        return 'OareDashboardSidebar';
      } else if (
        routeName &&
        (routeName.includes('admin') ||
          routeName.includes('manage') ||
          routeName.includes('denylist'))
      ) {
        return 'OareAdminSidebar';
      }
      return 'OareSidebar';
    });

    return {
      drawer,
      hasLanded,
      sidebarComponent,
    };
  },
});
</script>

<style>
* {
  font-family: 'Gentium Basic', serif;
}

@font-face {
  font-family: 'Santakku';
  src:
    local('Santakku'),
    url('./assets/fonts/Santakku.ttf') format('truetype');
}

@font-face {
  font-family: 'CuneiformComposite';
  src:
    local('CuneiformComposite'),
    url('./assets/fonts/CuneiformComposite.ttf') format('truetype');
}

.oare-header {
  font-size: 1.5rem;
}

.oare-title {
  font-size: 1.25rem;
}
</style>
